export function openLink(link) {
    if (window.Telegram.WebApp) {
        if (link.startsWith('https://t.me')) {
            window.Telegram.WebApp.openTelegramLink(link);
        } else {
            window.Telegram.WebApp.openLink(link);
        }
    } 
}
